import { CheckoutSession } from '@nemuru-eng/js-api-client';

import { UseDialogProps } from '@/components/shared/components/ConditionsSummary/LoanConditionsSummary/components/LenderApplications/components/LoanApplicationActionDialog/LoanApplicationActionDialog';
import { DistributionDialog } from '@/components/shared/components/DistributionDialog/DistributionDialog';
import { EditCheckoutSessionCartDialog } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/Header/CheckoutSessionActions/components/EditCheckoutSessionCartDialog/EditCheckoutSessionCartDialog';
import { EditCheckoutSessionDownPaymentDialog } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/Header/CheckoutSessionActions/components/EditCheckoutSessionDownPaymentDialog/EditCheckoutSessionDownPaymentDialog';
import { CancelCheckoutSessionDialog } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/Header/CheckoutSessionActions/components/CancelCheckoutSessionDialog';
import { DistributionHistoryDialog } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/Header/CheckoutSessionActions/components/DistributionHistoryDialog/DistributionHistoryDialog';
import { CheckoutSessionDetailAction } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/Header/CheckoutSessionActions/types/CheckoutSessionDetailAction';

interface LoanDetailActionsDialogProps {
  checkoutSession: CheckoutSession;
  currentAction: CheckoutSessionDetailAction;
  useDialogProps: UseDialogProps;
  hppId?: string;
}

export const CheckoutSessionDetailActionsDialog = ({
  checkoutSession,
  currentAction,
  useDialogProps,
  hppId,
}: LoanDetailActionsDialogProps) => {
  const { opened, setOpened, toggleDialog } = useDialogProps;

  return (
    <>
      {currentAction === CheckoutSessionDetailAction.EDIT_CART && (
        <EditCheckoutSessionCartDialog checkoutSession={checkoutSession} opened={opened} setOpened={setOpened} />
      )}
      {currentAction === CheckoutSessionDetailAction.EDIT_DOWN_PAYMENT && (
        <EditCheckoutSessionDownPaymentDialog checkoutSession={checkoutSession} opened={opened} setOpened={setOpened} />
      )}
      {currentAction === CheckoutSessionDetailAction.SHARE && hppId && (
        <DistributionDialog
          hppId={hppId}
          agentId={checkoutSession.agentId}
          opened={opened}
          setOpened={setOpened}
          checkoutSession={checkoutSession}
        />
      )}
      {currentAction === CheckoutSessionDetailAction.CANCEL_CHECKOUT_SESSION && (
        <CancelCheckoutSessionDialog
          opened={opened}
          setOpened={setOpened}
          toggleDialog={toggleDialog}
          checkoutSession={checkoutSession}
        />
      )}
      {currentAction === CheckoutSessionDetailAction.SEE_DISTRIBUTIONS && hppId && (
        <DistributionHistoryDialog
          hppId={hppId}
          checkoutSession={checkoutSession}
          opened={opened}
          setOpened={setOpened}
        />
      )}
    </>
  );
};
